import {defineMessages} from 'react-intl';

import localization from '@services/localization';

const messages = defineMessages({
  totalPeople: {
    id: 'useFullPersonTypes.constants.messages',
    defaultMessage: 'Total People',
  },
});

export const TOTAL_PEOPLE = 'TOTAL_PEOPLE';
export const TOTAL_PEOPLE_DISPLAY_NAME = localization.formatMessage(messages.totalPeople);
export const TOTAL_PEOPLE_PERSON_TYPE = {id: TOTAL_PEOPLE, name: TOTAL_PEOPLE_DISPLAY_NAME};
